import axios from 'axios';
import { API_PATHS } from 'common/utils/constants/api.constants';
import { CommercialUserDetail, PrivateUserDetail, UserConsents, UserDetail, UserPayload } from '../types/user.types';
import { CustomerAffinity } from 'modules/policies/types/policy.types';

export class UserService {
  /**
   * Locale will be used as header parameter , locale: string
   * @returns User details to be shown in rofile page for private user
   */
  static async getPrivateUserDetails(): Promise<PrivateUserDetail> {
    return await axios.get(`${API_PATHS.USERS}`).then((res) => res.data);
  }

  /**
   * Locale will be used as header parameter , locale: string
   * @returns User details to be shown in rofile page for commercial user
   */
  static async getCommercialUserDetails(): Promise<CommercialUserDetail> {
    return await axios.get(`${API_PATHS.USERS}`).then((res) => res.data);
  }

  // API path can be different for consents of commercial users and private users
  /**
   * @returns : all consents for private user
   */
  static async getAllPrivateConsentsDetails(): Promise<UserConsents> {
    return await axios.get(`${API_PATHS.USERS}/consent`).then((res) => res.data);
  }

  /**
   * @returns : all consents for commercial user
   */
  static async getAllCommercialConsentsDetails(): Promise<UserConsents> {
    return await axios.get(`${API_PATHS.USERS}/consent`).then((res) => res.data);
  }

  /**
   * @param payload : Payload of commercial contact
   * @returns : Contact details of commercial user
   */
  static async updateCommercialUserContactDetails({ payload }: UserPayload): Promise<void> {
    return await axios.put(`${API_PATHS.USERS}/updateContactPerson`, payload);
  }

  /**
   * @param payload : Payload of private contact
   * @returns : Contact details of commercial user
   */
  static async updatePrivateUserContactDetails({ payload }: UserPayload): Promise<void> {
    return await axios.put(`${API_PATHS.USERS}/updatePrivateContactPerson`, payload);
  }

  // Same API paths will be available for updating the information for consents, address and payment.

  /**
   * @param payload : Address payload
   * @returns : Address details of any user (private or commercial)
   */
  // static async updateUserAddressDetails({ payload }: UserPayload): Promise<void> {
  //   return await axios.put(`${API_PATHS.USERS}/address`, payload);
  // }

  static async updateUserAddressDetails({ payload }: UserPayload): Promise<void> {
    return await axios.put(`${API_PATHS.USERS}/updateAddress`, payload);
  }

  /**
   * @param payload : Consent payload
   * @returns : Consent details of any user (private or commercial)
   */
  static async updateUserConsentDetails({ payload }: UserPayload): Promise<void> {
    return await axios.put(`${API_PATHS.USERS}/updateConsents`, payload);
  }

  /**
   * @param payload : Reservation payload
   * @returns : Reservation details of any user (private or commercial)
   */
  static async updateUserReservationDetails({ payload }: UserPayload): Promise<void> {
    return await axios.put(`${API_PATHS.USERS}/updateReservation`, payload);
  }

  /**
   * @param payload : Payment payload
   * @returns : Payment details of any user (private or commercial)
   */
  static async updateUserPaymentDetails({ payload }: UserPayload): Promise<void> {
    return await axios.put(`${API_PATHS.USERS}/payment`, payload);
  }

  static async updateUserCompanyDetails({ payload }: UserPayload): Promise<void> {
    return await axios.put(`${API_PATHS.USERS}/updateCompany`, payload);
  }

  static async getCustomerInformation(): Promise<UserDetail> {
    return await axios.get(`${API_PATHS.CUSTOMER_INFORMATION}`).then((res) => res.data);
  }
  public static getCustomerAffinity(): Promise<CustomerAffinity> {
    return axios.get(`${API_PATHS.CUSTOMER_AFFINITY_INFO}`).then((r) => r.data);
  }

  /**
   * 
   * @param ssn : Customer civil registration number
   * @param upd : Update param
   * @returns : PartyId & error details
   */
  static updateUserData(ssn: string | undefined, upd: string) {
    return axios.post(`${API_PATHS.CREATE_PARTY}?ssn=${ssn}&upd=${upd}`).then((res) => res.data);
  }

  /**
   * 
   * @param segmentSelected : Customer segment param
   * @returns : Updated user details
   */
  static async updateUserSegment(segmentSelected: string): Promise<UserDetail> {
    return axios.put(`${API_PATHS.UPDATE_CUSTOMER_SEGMENT}?segmentSelected=${segmentSelected}`).then((res) => res.data)
  }
}
